import CoreEvent from '@/core/event/coreEvent';

class ViewEvent extends CoreEvent {

    constructor(type:string, id?:string, params = {}) {
        let data:{id?:string, params:any} = {
            id, params
        };

        super(type, data);
    }

    static get LOAD():string {
        return 'ViewEvent.viewLoadEvent';
    }

    static get START_LOADING():string {
        return 'ViewEvent.viewStartLoadingEvent';
    }

    static get LOADING_COMPLETE() {
        return 'ViewEvent.viewLoadingCompleteEvent';
    }

    static get UNLOAD() {
        return 'ViewEvent.viewUnloadEvent';
    }

    static get CHANGED() {
        return 'ViewEvent.viewChanged';
    }

}

export default ViewEvent;
